import {
  ActionGroup,
  Flex,
  Item,
  Selection,
  View,
  Text,
  ActionButton,
  Divider,
} from "@adobe/react-spectrum";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  API_DOWNLOAD_ATTACHMENT,
  CHAT_ATTACHMENT_BUTTONS,
} from "../../../constants/constants";
import { Tabs } from "../../../types/generic.types";
import "./style.css";
import {
  DefaultEyeIcon,
  DefaultImageIcon,
  DownloadIcon,
} from "../../common/Icons";
import Emitter from "../../../emitter";
import { IndividualChat } from "../../../types/chat.type";
import { RootState } from "../../../store/storeConfig";

const Attachments = () => {
  const chat = useSelector((state: RootState) => state.chat);

  const [selectedState, setSelectedState] = useState<Selection>(
    new Set(["All"])
  );
  const [allAttachments, setAllAttachments] = useState<any[]>([]);
  const [activeChat, setActiveChat] = useState<IndividualChat | null>(null);

  useEffect(() => {
    const active = chat.chats.find(
      (chatItem: IndividualChat) => chatItem.id === chat.activeChatID
    );
    setActiveChat(active || null);
  }, [chat.activeChatID, chat.chats]);

  const downloadAttachment = (attachmentId: string, name: string) => {
    Emitter.emit(API_DOWNLOAD_ATTACHMENT, {
      body: { contactId: activeChat?.id, attachmentId, attachmentName: name },
      type: "req",
    });
  };

  useEffect(() => {
    if (!activeChat) return;
    const selectedKey = [...selectedState][0];
    const roleMap: { [key: string]: string } = {
      Users: "CUSTOMER",
      Me: "AGENT",
    };

    // Combine chat transcript + messages
    const combinedMessages = [
      ...(activeChat?.transcript || []),
      ...(activeChat?.messages || []),
    ];

    const filteredAttachments = combinedMessages.filter((item: any) => {
      const isAttachment = Array.isArray(item.text);
      const matchesRole =
        selectedKey === "All" || item.role === roleMap[selectedKey];

      return isAttachment && matchesRole;
    });

    setAllAttachments(filteredAttachments || []);
  }, [activeChat, selectedState]);

  return (
    <View UNSAFE_className="chat-attachments-container">
      <Flex direction={"row"} UNSAFE_className="chat-attachment-btns">
        <ActionGroup
          selectionMode="single"
          selectedKeys={selectedState}
          onSelectionChange={setSelectedState}
        >
          {CHAT_ATTACHMENT_BUTTONS.map((button: Tabs) => (
            <Item key={button.name}>
              <Text UNSAFE_className="call-monitor-action-btn">
                {button.name}
              </Text>
            </Item>
          ))}
        </ActionGroup>
      </Flex>

      <Flex
        direction="column"
        UNSAFE_className="chat-history-attribute-container"
      >
        {allAttachments?.length > 0 ? (
          allAttachments.map((attachment: any, index: number) => (
            <View paddingY="size-150" key={index}>
              <Flex alignItems="center" justifyContent="space-between">
                <Flex alignItems="center" gap={"size-100"}>
                  <DefaultImageIcon />
                  <Flex direction={"column"}>
                    <Text
                      UNSAFE_className="chat-attachment"
                      UNSAFE_style={{ fontWeight: 500 }}
                    >
                      {attachment?.text?.[0]?.AttachmentName}
                    </Text>
                    <Text UNSAFE_className="chat-attachment-ext">
                      {attachment?.text?.[0]?.AttachmentName?.split(".")
                        ?.pop()
                        ?.toUpperCase()}
                    </Text>
                  </Flex>
                </Flex>
                <Flex alignItems={"center"}>
                  <ActionButton
                    isQuiet
                    onPress={() =>
                      downloadAttachment(
                        attachment?.text?.[0]?.AttachmentId,
                        attachment?.text?.[0]?.AttachmentName
                      )
                    }
                  >
                    <DownloadIcon color="#0265dc" />
                  </ActionButton>
                  {/* <ActionButton isQuiet>
                    <DefaultEyeIcon />
                  </ActionButton> */}
                </Flex>
              </Flex>
              <Divider size="S" marginTop="size-150" />
            </View>
          ))
        ) : (
          <Text marginTop={20}>No attachments found</Text>
        )}
      </Flex>
    </View>
  );
};

export default Attachments;
